var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.IS_LOADING.status)?_c('div',{staticClass:"content-container flex flex-col w-full px-8"},[_c('Header1',{attrs:{"label":"Admin Home"}}),_vm._m(0)],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Welcome to epasnets Dashboard")])])
}]

export { render, staticRenderFns }